import { Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LOCAL_USER_KEY } from 'global';
import { interval } from 'rxjs';
import { ApiService } from './api.service';
import { AuthService } from './core/auth/auth.service';
import { ImpersonationBannerComponent } from './core/impersonation/impersonation-banner/impersonation-banner.component';
import { BannerCommunityConn } from './modules/admin/communities/banner/community-connection.component';
import ToastComponent from './modules/client/live/components/toast';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: true,
    imports: [RouterOutlet, ToastComponent, BannerCommunityConn, ImpersonationBannerComponent],
})
export class AppComponent implements OnInit {
    private _api = inject(ApiService);
    // Device handle for your USB device
    private deviceHandle: any;
    communityCompanyKey: string | null = null;
    isAuthenticated: boolean = false;

    /**
     * Constructor
     */
    constructor(private _authService: AuthService) {}

    ngOnInit() {
        // Estado inicial inmediato (evita ~1s de flicker del banner tras un reload).
        this.isAuthenticated = this.isAuthenticatedUser();

        interval(1000).subscribe(() => {
            const user_data = JSON.parse(window.localStorage.getItem(LOCAL_USER_KEY) ?? '{}');
            const value = `[${user_data?.id_company}-${user_data?.id_community}]`;

            if (this.communityCompanyKey && this.communityCompanyKey !== value) {
                window.location.reload();
            } else {
                this.communityCompanyKey = value;
            }
            this.isAuthenticated = this.isAuthenticatedUser();
        });
    }

    ngAfterViewInit() {}

    isAuthenticatedUser(): boolean {
        return this._authService.accessToken ? true : false;
    }
}
